export function buildODataQuery({ filter, top, skip } = {}) {
  const params = new URLSearchParams()
  if (filter) params.append('$filter', filter)
  if (top != null) params.append('$top', String(top))
  if (skip != null) params.append('$skip', String(skip))
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}
